import { render, staticRenderFns } from "./inventory.index.vue?vue&type=template&id=12aadc6b&"
import script from "./inventory.index.vue?vue&type=script&lang=js&"
export * from "./inventory.index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports